module.exports = __webpack_public_path__ + "media/images/new_landing/for/price-2-c75fa2e82e1300ab3981e519bca9cd30.png";